import type { Product } from "@fa/shared";
import { PRODUCT_LABELS } from "@fa/shared";
import { MotorForm } from "./products/MotorForm";
import { PiForm } from "./products/PiForm";
import { IndividualMedicalForm } from "./products/IndividualMedicalForm";
import { GroupMedicalForm } from "./products/GroupMedicalForm";
import { ApiContext } from "./api";

export function App({ product, apiBase }: { product: Product; apiBase: string }) {
  return (
    <ApiContext.Provider value={{ baseUrl: apiBase }}>
      <div className="fa-max-w-5xl fa-mx-auto fa-p-4 fa-font-fa">
        <h1 className="fa-text-center fa-text-2xl fa-font-bold fa-text-faInk fa-uppercase fa-mb-1">
          {PRODUCT_LABELS[product]} for ICPAK Members
        </h1>
        <p className="fa-text-center fa-text-sm fa-text-slate-500 fa-mb-6">
          Fields marked with <span className="fa-text-red-500 fa-font-semibold">*</span> are required.
        </p>
        {product === "motor_private" && <MotorForm />}
        {product === "pi" && <PiForm />}
        {product === "individual_medical" && <IndividualMedicalForm />}
        {product === "group_medical" && <GroupMedicalForm />}
        <p className="fa-text-xs fa-italic fa-text-slate-500 fa-mt-8">
          First Assurance Kenya Limited takes your data privacy seriously. Any
          information you provide will be used solely for the purpose of
          facilitating the creation of a contract of insurance to which you are
          a party. Read our Privacy Policy on{" "}
          <a
            href="https://firstassurance.co.ke/privacy-policy/"
            className="fa-underline"
            target="_blank"
            rel="noreferrer"
          >
            firstassurance.co.ke
          </a>
          .
        </p>
      </div>
    </ApiContext.Provider>
  );
}
